import { LabelVariant } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';

export const ORIGINAL_CHIP = { title: 'Original', variant: LabelVariant.BLUE };

export const COMMENT_UNCHANGED_LABEL = 'Comment unchanged';

export const ORIGINAL_ENTRY_ACTION = 'entered the original reason';

export const COMMENT_CHANGE_PREFIX = 'Comment:';
